module.exports = __webpack_public_path__ + "img/arr-left.4737033d.svg";